import React, { ReactNode } from 'react';
import { createStyles } from '../../utils/css';
import { MODAL_BORDER_RADIUS } from './Modal';

export enum ModalFooterAlignment {
  Center = 'center',
  Left   = 'left',
  Right  = 'right',
}

interface IModalFooterProps {
  children: ReactNode;
  align?: ModalFooterAlignment;
}

const ModalFooter = ({ children, align = ModalFooterAlignment.Right }: IModalFooterProps) =>
  <Styles>{(css) =>
    <div className={css(align)}>{children}</div>
  }</Styles>;

const sharedStyles = {
  padding: '1em',
  backgroundColor: '#eee',
  borderRadius: `0 0 ${MODAL_BORDER_RADIUS}px ${MODAL_BORDER_RADIUS}px`,
  flexGrow: 0,
  display: 'flex',
};

const Styles = createStyles({
  [ModalFooterAlignment.Center]: {
    ...sharedStyles,
    justifyContent: 'center',
  },
  [ModalFooterAlignment.Left]: {
    ...sharedStyles,
    justifyContent: 'flex-start',
  },
  [ModalFooterAlignment.Right]: {
    ...sharedStyles,
    justifyContent: 'flex-end',
  },
});

export default ModalFooter;
